import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { UserService } from '../../services';
import { AuthActionTypes } from '../actions/auth.actions';
import { UserActionTypes } from '../actions/user.actions';
import { ofType, Actions, createEffect } from '@ngrx/effects';

/**
 * UserEpics
 */
@Injectable()
export class UserEffects {
  /**
   * constructor
   * @param {UserService} userService
   */
  constructor(private userService: UserService, private actions$: Actions) {}

  /**
   * loadUser
   * @param {ActionsObservable<any>} action$
   * @returns {Observable<any>}
   */
  loadUser = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActionTypes.LOAD_USER, UserActionTypes.PATCH_USER),
      switchMap(() => {
        // TODO - replace w. getOktaUser() when integration of Okta SSO
        return this.userService.getUser().pipe(
          map((user) => ({
            type: UserActionTypes.LOAD_USER_SUCCESS,
            payload: user,
          })),
          catchError((err) => of({ type: UserActionTypes.LOAD_USER_ERROR, payload: err })),
        );
      }),
    ),
  );

  /**
   * loadUserError
   * @param {ActionsObservable<any>} action$
   * @returns {Observable<any>}
   */
  // loadUserError = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(UserActionTypes.LOAD_USER_ERROR),
  //     map(() => ({ type: AuthActionTypes.LOGOUT })),
  //   ),
  // );
}
